import { Box, Paper, Typography } from '@mui/material';
import { comingSoonStyle } from '../../themes/commonStyle';

export type HowTosSectionPosition = 'left' | 'right';


type HowTosSectionProps = {
  image: string;
  title: string;
  titleStyle: React.CSSProperties;
  description: string;
  comingSoon?: boolean;
};

export const HowTosSection = ({ image, title, titleStyle, description, comingSoon }: HowTosSectionProps) => {

  return (
    <Box sx={{ textAlign: 'center', maxWidth: 800 }}>
      <Typography sx={styles.sectionTitle} gutterBottom>
        <span style={titleStyle}>{title}</span><></>
        <span style={comingSoonStyle}>{comingSoon && ' (Coming Soon)'}</span>
      </Typography>
      <Typography sx={styles.sectionBody} gutterBottom>{description}</Typography>
      <img src={image} style={styles.sectionImage} />
    </Box>
  );
};

const styles = {
  sectionImage: {
    //height: 400,
    objectFit: 'cover' as 'cover',
    objectPosition: 'center',
    width: '100%',
  },
  sectionTitle: {
    typography: 'h5',
    textAlign: 'left',
  },
  sectionBody: {
    typography: 'body1',
    textAlign: 'left',
  },
  comingSoon: {
    typography: 'body2',
    color: 'lightcoral',
  },
};
